export default "__VITE_ASSET__gkHQ2ioM__"